export const getCategories = '/api/v2/faq_categories';
export const getQuestionsByCategory = categorySlug => `${getCategories}/${categorySlug}`;
export const getHelpUrl = categorySlug => `/help/${categorySlug}`;
